import React from "react";
import SingleCardHeadshotSm from "@qlik/qlik/src/components/Card/Single-Card-headshot-Small";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import RichText from "@qlik/qlik/src/components/RichText";
import * as styles from "./styles.module.css";

/**
 * HeadshotCard component
 * @param {Object} data - The data for the headshot card.
 */
const HeadshotCard = ({ data }) => {
    const { title, cardItems = [], additionalConfiguration, numberOfColumns, customId } = data ?? {};
    const renderFirstRow = title || data?.body?.raw;
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "");
    const headlineMBottom = data?.body?.raw ? "mb-5" : "";

    return (
        <section className={`py-12.5 md:pt-30 md:pb-20 ${sectionSpacingClassName}`} id={customId}>
            <div className="container">
                {/* Render the first row if title or description exists */}
                {renderFirstRow && (
                    <div className="row">
                        <div className="col-12 mb-5 md:mb-15">
                            {title && <h2 className={`text-center ${headlineMBottom}`}>{title}</h2>}
                            {data?.body?.raw && <RichText data={data} className={styles.headshotRichtext} />}
                        </div>
                    </div>
                )}

                <div
                    className={`grid md:grid-cols-3 gap-x-7.5 gap-y-12.25 ${
                        numberOfColumns === null ? "lg:grid-cols-5" : `lg:grid-cols-${numberOfColumns || 5}`
                    }`}
                >
                    {/* Map through the card items and render each one */}
                    {cardItems?.map((cardItem) => (
                        <SingleCardHeadshotSm
                            key={cardItem.id}
                            media={cardItem?.media?.[0]}
                            name={cardItem?.title}
                            country={cardItem?.subtitle}
                            title={cardItem?.description?.description.split("\n")}
                            richcontent={cardItem}
                            ctaList={cardItem?.cta}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HeadshotCard;
